// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".EzXqax_1JbaK6rBZfVhc{margin-bottom:5px;color:#f56565 !important}@media(min-width: 768px){.EzXqax_1JbaK6rBZfVhc{margin-bottom:12px}}.BHsMz5xwvXaeLmoL34uA p{margin-bottom:8px}.BHsMz5xwvXaeLmoL34uA ol{list-style:decimal;list-style-position:inside}.BHsMz5xwvXaeLmoL34uA ol li{padding:2px 0px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"errorTitle": "EzXqax_1JbaK6rBZfVhc",
	"errorAssign": "BHsMz5xwvXaeLmoL34uA"
};
export default ___CSS_LOADER_EXPORT___;
